import React from 'react';
import qs from 'query-string';

import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';

import Successful from './successful';
import Unsuccessful from './unsuccessful';

export const Unsubscribe = () => {
  const { success: unsubscribeSuccessful } = qs.parse(window?.location?.search);

  const communicationPreferencesUrl = `/account/settings/communication-preferences`;

  return (
    <ContentColumn className="py6 lg-py9" size="sm">
      {unsubscribeSuccessful === 'true' ? (
        <Successful communicationPreferencesUrl={communicationPreferencesUrl} />
      ) : (
        <Unsuccessful
          communicationPreferencesUrl={communicationPreferencesUrl}
        />
      )}
    </ContentColumn>
  );
};

export default Unsubscribe;
